import React from 'react'
import ReactDOM from 'react-dom/client'
import UnykornLanding from './UnykornLanding.tsx'
import XappLanding from './XappLanding.tsx'
import ReviewerLanding from './ReviewerLanding.tsx'
import { initStorage } from './utils/xummStorage'

const isXappRoute = (() => {
  if (typeof window === 'undefined') return false
  const p = window.location?.pathname || '/'
  return p === '/xapp' || p.startsWith('/xapp/')
})()

const isReviewerRoute = (() => {
  if (typeof window === 'undefined') return false
  const p = window.location?.pathname || '/'
  return p === '/review' || p.startsWith('/review/')
})()

// Initialize storage system before rendering
initStorage().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      {isXappRoute ? <XappLanding /> : isReviewerRoute ? <ReviewerLanding /> : <UnykornLanding />}
    </React.StrictMode>,
  )
}).catch(err => {
  console.error('[App] Failed to initialize storage:', err)
  // Still render the app even if storage init fails
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      {isXappRoute ? <XappLanding /> : isReviewerRoute ? <ReviewerLanding /> : <UnykornLanding />}
    </React.StrictMode>,
  )
})
